import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationId = () => {
  useEffect(() => {
    document.documentElement.lang = "id";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>Pedoman Komunitas pregnancy&baby</PolicyTitle>
      <PolicyVersion>
        Tanggal Berlaku: 21 September 2026
        <br />
        Terakhir Diperbarui: 25 Agustus 2026
      </PolicyVersion>

      <PolicyText>
        Pedoman Komunitas ini (“Pedoman”) menetapkan aturan dan standar dalam
        menggunakan fitur komunitas yang tersedia melalui{" "}
        <strong>pregnancy&baby</strong>, layanan yang dioperasikan oleh Connecti
        Co., Ltd. (“Perusahaan”, “kami”).
      </PolicyText>
      <PolicyText>
        Komunitas pregnancy&baby merupakan ruang bagi pengguna untuk berbagi
        pengalaman, kekhawatiran, pertanyaan, dan informasi mengenai persiapan
        kehamilan, perawatan kesuburan, kehamilan, persalinan, pengasuhan anak,
        serta berbagai topik lainnya.
      </PolicyText>
      <PolicyText>
        Kami ingin pregnancy&baby menjadi ruang yang aman, nyaman, dan saling
        menghormati, tempat pengguna dapat berkomunikasi secara terbuka serta
        saling memberikan dukungan. Harap membaca dan mematuhi Pedoman ini saat
        menggunakan fitur komunitas.
      </PolicyText>
      <PolicyText>
        Pedoman ini melengkapi{" "}
        <strong>Ketentuan Penggunaan pregnancy&baby</strong>. Apabila aktivitas
        pengguna melanggar peraturan perundang-undangan yang berlaku, Ketentuan
        Penggunaan, atau Pedoman ini, Perusahaan dapat mengambil tindakan yang
        sesuai, termasuk membatasi atau menghapus Konten serta membatasi
        penggunaan fitur komunitas.
      </PolicyText>
      <PolicyText>
        Perusahaan dapat memperbarui Pedoman ini apabila diperlukan untuk
        menjaga lingkungan komunitas yang aman dan sehat. Perubahan yang
        bersifat material akan diberitahukan terlebih dahulu melalui Layanan
        sesuai dengan Ketentuan Penggunaan dan peraturan perundang-undangan yang
        berlaku.
      </PolicyText>

      <PolicySectionTitle>1. Profil Anda Mewakili Anda</PolicySectionTitle>
      <PolicyText>
        Nama panggilan dan foto profil membantu pengguna lain mengenali Anda di
        dalam komunitas.
      </PolicyText>
      <PolicyText>
        Harap gunakan informasi profil yang sesuai untuk mewakili diri Anda.
      </PolicyText>
      <PolicyText>
        Profil dapat dibatasi atau diminta untuk diubah apabila:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Memuat konten atau gambar yang tidak pantas, menyinggung, cabul, atau
          melanggar hukum;{" "}
        </li>
        <li>
          Menggunakan nama, merek dagang, logo, gambar, atau materi yang
          dilindungi milik individu atau organisasi lain tanpa izin;{" "}
        </li>
        <li>
          Menyamar sebagai orang lain, perusahaan, organisasi, staf atau
          pengelola pregnancy&baby; atau{" "}
        </li>
        <li>
          Dapat menyesatkan atau menimbulkan kebingungan bagi pengguna lain
          mengenai identitas atau kedudukan pengguna.
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Memposting Konten di Komunitas</PolicySectionTitle>
      <PolicyText>
        Konten yang diposting di komunitas pregnancy&baby dapat dilihat oleh
        anggota lain.
      </PolicyText>
      <PolicyText>
        Sebelum memposting, harap pastikan bahwa postingan, komentar, gambar,
        atau Konten Anda tidak memuat data pribadi, informasi pribadi, atau
        informasi sensitif yang tidak ingin Anda bagikan kepada orang lain.
      </PolicyText>
      <PolicyText>
        Semua postingan, komentar, informasi profil, gambar, dan Konten lainnya
        harus mematuhi Pedoman ini dan Ketentuan Penggunaan pregnancy&baby.
      </PolicyText>

      <PolicySectionTitle>
        3. Melaporkan Konten yang Tidak Pantas
      </PolicySectionTitle>
      <PolicyText>
        Apabila Anda menemukan postingan atau komentar yang menurut Anda
        melanggar Pedoman ini, seperti spam, iklan tanpa izin, perundungan,
        pelecehan, penghinaan, atau Konten tidak pantas lainnya, Anda dapat
        menggunakan fitur Laporkan yang tersedia dalam Layanan.
      </PolicyText>
      <PolicyText>
        Laporan dari pengguna membantu kami menjaga komunitas agar tetap aman
        dan saling menghormati.
      </PolicyText>
      <PolicyText>
        Perusahaan dapat meninjau Konten yang dilaporkan dan mengambil tindakan
        yang sesuai berdasarkan Pedoman ini, Ketentuan Penggunaan, dan peraturan
        perundang-undangan yang berlaku.
      </PolicyText>

      <PolicySectionTitle>
        4. Konten dan Perilaku yang Dilarang
      </PolicySectionTitle>
      <PolicyText>
        Konten dan perilaku berikut tidak diperbolehkan di komunitas
        pregnancy&baby.
      </PolicyText>

      <PolicyArticleTitle>
        4.1 Konten Seksual atau Pornografi
      </PolicyArticleTitle>
      <PolicyText>Dilarang memposting Konten yang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Memuat gambaran atau gambar seksual yang terlalu eksplisit, cabul,
          atau tidak pantas;{" "}
        </li>
        <li>
          Mempromosikan, menawarkan, menjadi perantara, atau memfasilitasi
          prostitusi atau layanan seksual yang melanggar hukum;{" "}
        </li>
        <li>
          Bertujuan mempermalukan, melecehkan, atau menyinggung orang lain
          secara seksual; atau{" "}
        </li>
        <li>
          Mengandung eksploitasi seksual atau Konten seksual lainnya yang
          melanggar hukum.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.2 Aktivitas atau Transaksi yang Melanggar Hukum
      </PolicyArticleTitle>
      <PolicyText>Dilarang menggunakan komunitas untuk:</PolicyText>
      <PolicyHyphenList>
        <li>
          Mempromosikan atau memfasilitasi perjudian yang melanggar hukum;{" "}
        </li>
        <li>
          Menjual, membeli, menukar, atau menawarkan barang atau jasa yang
          melanggar hukum;{" "}
        </li>
        <li>
          Menjual atau mempromosikan produk yang dilarang untuk diperjualbelikan
          secara daring berdasarkan peraturan perundang-undangan yang berlaku;
          atau{" "}
        </li>
        <li>
          Memberikan informasi yang bertujuan mendorong, membantu, atau
          memfasilitasi tindakan yang melanggar hukum.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.3 Konten Berbahaya, Kekerasan, atau Mengganggu
      </PolicyArticleTitle>
      <PolicyText>Dilarang memposting Konten yang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Memuat gambar atau deskripsi yang sangat sadis, mengerikan, atau
          mengganggu, termasuk tubuh yang mengalami luka berat atau gambaran
          kematian secara eksplisit;{" "}
        </li>
        <li>Mengandung atau memfasilitasi eksploitasi seksual; </li>
        <li>
          Mengancam, memaksa, membujuk, atau memancing orang lain untuk tujuan
          eksploitasi seksual;{" "}
        </li>
        <li>Mendorong, mendukung, atau mengagungkan kekerasan; </li>
        <li>
          Mendorong diskriminasi, kebencian, atau permusuhan terhadap seseorang
          atau kelompok berdasarkan ras, kebangsaan, etnis, warna kulit, agama
          atau kepercayaan, jenis kelamin, disabilitas, atau karakteristik
          pribadi lainnya; atau{" "}
        </li>
        <li>
          Mendorong, membantu, atau mempromosikan tindakan bunuh diri atau bunuh
          diri bersama.
        </li>
      </PolicyHyphenList>
      <PolicyArticleTitle>Tentang SARA</PolicyArticleTitle>
      <PolicyText>
        Konten yang menghasut atau mendorong kebencian, permusuhan, atau
        diskriminasi berdasarkan suku, agama, ras, dan antargolongan (SARA)
        tidak diperbolehkan.
      </PolicyText>

      <PolicyArticleTitle>4.4 Iklan, Promosi, dan Penawaran</PolicyArticleTitle>
      <PolicyText>
        Iklan komersial, promosi, penawaran, kegiatan pemasaran, atau spam yang
        tidak mendapat izin dari Perusahaan dapat dibatasi atau dihapus.
      </PolicyText>
      <PolicyText>Hal ini termasuk, namun tidak terbatas pada:</PolicyText>
      <PolicyHyphenList>
        <li>
          Memposting iklan atau Konten promosi yang sama atau serupa secara
          berulang;{" "}
        </li>
        <li>
          Postingan yang tujuan utamanya adalah mempromosikan produk atau
          jasa;{" "}
        </li>
        <li>
          Konten yang bertujuan mengarahkan pengguna ke kegiatan komersial atau
          transaksi eksternal yang tidak diizinkan; atau{" "}
        </li>
        <li>
          Menggunakan komunitas terutama untuk berjualan, mencari pelanggan,
          atau melakukan pemasaran.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Perusahaan tidak terlibat dalam, menjamin, atau bertanggung jawab atas
        transaksi yang dilakukan secara sukarela antar pengguna sebagai akibat
        dari postingan atau interaksi dalam komunitas, kecuali ditentukan lain
        oleh peraturan perundang-undangan yang berlaku.
      </PolicyText>
      <PolicyText>
        Apabila Anda menemukan aktivitas komersial, iklan, atau promosi yang
        mencurigakan, silakan gunakan fitur Laporkan dalam Layanan.
      </PolicyText>

      <PolicyArticleTitle>
        4.5 Perundungan, Pelecehan, Penghinaan, Pencemaran Nama Baik, dan
        Penyamaran
      </PolicyArticleTitle>
      <PolicyText>Dilarang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Berulang kali menghina, mengancam, merundung, melecehkan, atau
          menyerang orang lain;{" "}
        </li>
        <li>
          Menggunakan bahasa yang sangat kasar, merendahkan, menghina, atau
          menyerang pengguna lain;{" "}
        </li>
        <li>
          Menyamar sebagai pregnancy&baby, Perusahaan, karyawan, pengelola, atau
          orang lain;{" "}
        </li>
        <li>
          Memberikan informasi palsu mengenai identitas atau kedudukan untuk
          menipu pengguna lain atau memperoleh keuntungan yang tidak
          semestinya;{" "}
        </li>
        <li>
          Dengan sengaja menyebarkan informasi palsu atau menyesatkan mengenai
          individu atau organisasi dengan cara yang dapat menimbulkan kerugian;
          atau{" "}
        </li>
        <li>
          Mempublikasikan Konten palsu seolah-olah merupakan berita, laporan,
          atau informasi resmi yang sah sehingga dapat menyesatkan pengguna.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.6 Perangkat Lunak Berbahaya dan Gangguan terhadap Layanan
      </PolicyArticleTitle>
      <PolicyText>Dilarang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Mengunggah, menyebarkan, atau menautkan virus, malware, kode
          berbahaya, atau perangkat lunak lain yang ditujukan untuk merusak atau
          mengganggu perangkat atau sistem;{" "}
        </li>
        <li>
          Mengganggu atau menghambat pengoperasian normal pregnancy&baby;{" "}
        </li>
        <li>Mengeksploitasi kerentanan dalam Layanan; atau </li>
        <li>
          Menggunakan metode otomatis atau tidak sah untuk menyebarkan iklan,
          promosi, permintaan pertemanan, permintaan interaksi, atau Konten
          serupa.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.7 Pelanggaran Hak Kekayaan Intelektual
      </PolicyArticleTitle>
      <PolicyText>
        Harap menghormati hak kekayaan intelektual pihak lain.
      </PolicyText>
      <PolicyText>Dilarang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Menggunakan karya, merek dagang, desain, gambar, atau materi lain yang
          dilindungi milik orang lain tanpa izin;{" "}
        </li>
        <li>
          Membagikan siaran, musik, film, animasi, foto, gambar, artikel,
          postingan, atau karya lainnya tanpa izin yang sesuai;{" "}
        </li>
        <li>
          Memberikan petunjuk atau informasi yang bertujuan memfasilitasi akses
          atau penggunaan karya berhak cipta secara melanggar hukum; atau{" "}
        </li>
        <li>
          Menyalin atau memposting ulang postingan, foto, atau gambar pengguna
          pregnancy&baby lainnya tanpa izin apabila tindakan tersebut melanggar
          hak pemiliknya.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.8 Data Pribadi dan Mengarahkan Percakapan ke Luar Layanan
      </PolicyArticleTitle>
      <PolicyText>
        Untuk membantu melindungi privasi dan keamanan pengguna, dilarang:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Meminta data pribadi pengguna lain melalui postingan atau
          komentar;{" "}
        </li>
        <li>
          Mengungkapkan data pribadi diri sendiri atau orang lain secara terbuka
          dengan cara yang dapat menimbulkan risiko terhadap privasi atau
          keselamatan; atau{" "}
        </li>
        <li>
          Secara berulang atau tidak pantas mengajak pengguna lain untuk
          memindahkan percakapan ke media sosial, aplikasi pesan, atau saluran
          lain di luar Layanan.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Saat membagikan informasi dalam komunitas, harap diingat bahwa informasi
        tersebut dapat dilihat oleh anggota lain.
      </PolicyText>

      <PolicyArticleTitle>
        4.9 Spam dan Perilaku yang Mengganggu Komunitas
      </PolicyArticleTitle>
      <PolicyText>Dilarang:</PolicyText>
      <PolicyHyphenList>
        <li>
          Memposting Konten yang sama atau secara substansial serupa secara
          berulang;{" "}
        </li>
        <li>
          Memposting Konten yang sama atau serupa di berbagai bagian
          Layanan;{" "}
        </li>
        <li>Memanipulasi atau menyalahgunakan fitur Layanan; </li>
        <li>
          Dengan sengaja mengganggu kemampuan pengguna lain untuk menggunakan
          Layanan secara normal; atau{" "}
        </li>
        <li>
          Melakukan tindakan lain yang secara signifikan mengganggu
          pengoperasian normal komunitas.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Meskipun suatu tindakan tidak disebutkan secara khusus dalam Pedoman
        ini, tindakan tersebut tetap dapat dibatasi apabila secara jelas
        mengganggu keamanan, integritas, atau pengoperasian normal Layanan atau
        secara signifikan mengganggu penggunaan Layanan oleh pengguna lain.
      </PolicyText>

      <PolicySectionTitle>
        5. Moderasi dan Pengelolaan Konten
      </PolicySectionTitle>
      <PolicyText>
        Apabila Konten melanggar peraturan perundang-undangan yang berlaku,
        Ketentuan Penggunaan pregnancy&baby, atau Pedoman ini, Perusahaan dapat
        mengambil satu atau beberapa tindakan berikut:
      </PolicyText>
      <PolicyHyphenList>
        <li>Membatasi visibilitas Konten; </li>
        <li>Menyembunyikan Konten untuk sementara; </li>
        <li>Menghapus Konten; </li>
        <li>Membatasi fitur posting atau komentar; </li>
        <li>Membatasi akses ke fitur komunitas tertentu; atau </li>
        <li>
          Mengambil tindakan lain yang secara wajar diperlukan untuk mencegah
          pelanggaran berlanjut atau timbulnya kerugian lebih lanjut.{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Perusahaan tidak berkewajiban untuk meninjau seluruh Konten pengguna
        sebelum dipublikasikan.
      </PolicyText>
      <PolicyText>
        Tetap ditampilkannya suatu Konten dalam Layanan tidak berarti bahwa
        Perusahaan telah menyetujui, mendukung, menjamin, atau memverifikasi
        kebenaran Konten tersebut.
      </PolicyText>

      <PolicySectionTitle>
        6. Pembatasan Akun dan Penggunaan Layanan
      </PolicySectionTitle>
      <PolicyText>
        Apabila pengguna melanggar peraturan perundang-undangan yang berlaku,
        Ketentuan Penggunaan, atau Pedoman ini, Perusahaan dapat membatasi akses
        pengguna ke fitur atau Layanan tertentu.
      </PolicyText>
      <PolicyText>
        Pembatasan dapat bersifat sementara atau permanen tergantung pada sifat,
        tingkat keparahan, dan frekuensi pelanggaran.
      </PolicyText>
      <PolicyText>
        Tindakan yang dapat dilakukan oleh Perusahaan meliputi:
      </PolicyText>
      <PolicyHyphenList>
        <li>Memberikan peringatan; </li>
        <li>Membatasi visibilitas Konten; </li>
        <li>Menghapus Konten; </li>
        <li>
          Membatasi sementara kemampuan untuk memposting atau berkomentar;{" "}
        </li>
        <li>Membatasi penggunaan fitur komunitas; </li>
        <li>Menangguhkan Akun untuk sementara; atau </li>
        <li>
          Membatasi atau menonaktifkan Akun secara permanen dalam kasus
          pelanggaran serius.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Perusahaan dapat segera mengambil tindakan yang diperlukan tanpa
        menerapkan pembatasan secara bertahap apabila terdapat aktivitas ilegal
        yang serius, eksploitasi seksual, perjudian ilegal, risiko keselamatan
        yang serius, serangan berbahaya terhadap Layanan, atau pelanggaran
        serius lainnya.
      </PolicyText>
      <PolicyText>
        Perusahaan juga dapat mengambil langkah perlindungan yang wajar apabila
        terdeteksi aktivitas Akun yang tidak normal, upaya akses tanpa izin,
        penyalahgunaan otomatis, atau aktivitas lain yang dapat mengancam
        pengguna atau Layanan.
      </PolicyText>

      <PolicySectionTitle>7. Permintaan Peninjauan Kembali</PolicySectionTitle>
      <PolicyText>
        Apabila Anda yakin bahwa Konten atau Akun Anda dibatasi karena
        kesalahan, Anda dapat menghubungi Dukungan Pelanggan pregnancy&baby
        untuk meminta peninjauan kembali.
      </PolicyText>
      <PolicyText>
        Perusahaan akan meninjau permintaan tersebut berdasarkan Pedoman ini,
        Ketentuan Penggunaan, dan peraturan perundang-undangan yang berlaku.
      </PolicyText>
      <PolicyText>
        <strong>Dukungan Pelanggan: after10month@connect-i.co.kr</strong>
      </PolicyText>

      <PolicySectionTitle>
        8. Hubungan dengan Ketentuan Penggunaan
      </PolicySectionTitle>
      <PolicyText>
        Pedoman ini merupakan bagian dari aturan yang berlaku dalam penggunaan
        pregnancy&baby dan harus dibaca serta diterapkan bersama dengan{" "}
        <strong>Ketentuan Penggunaan pregnancy&baby</strong>.
      </PolicyText>
      <PolicyText>
        Hal-hal yang tidak diatur secara khusus dalam Pedoman ini akan ditangani
        sesuai dengan Ketentuan Penggunaan, peraturan perundang-undangan yang
        berlaku, dan kebijakan Perusahaan lainnya yang berlaku.
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationId;
